import { useFirebaseAuth } from "./use-firebase-auth";
import { useFirestoreUserSWR } from "./use-firestore-user-swr";
import { User } from "./user";

export function useUser(): useUserReturn {
  const { userId, name, email, photoUrl, authenticated } = useFirebaseAuth();
  const { data: firestoreUser } = useFirestoreUserSWR();

  // Identity comes from auth; the Firestore document only enriches it, and the fields
  // it contributes are spread first so auth wins on any it also carries.
  const user: User = {
    ...firestoreUser,
    id: userId,
    authenticated,
    name,
    email,
    photoUrl,
  };

  return { user };
}

export type useUserReturn = {
  user: User;
};
